export default __webpack_public_path__ + "static/media/soc.73142a59.png";